import * as actionTypes from "./actionTypes";

export const acceptCookie = cookieStatus => {
  return {
    type: actionTypes.COOKIE_ACCEPTED,
    cookieStatus: cookieStatus
  };
};
